import { render, staticRenderFns } from "./qasHeldesk.vue?vue&type=template&id=9f76b51a&scoped=true&"
import script from "./qasHeldesk.vue?vue&type=script&lang=js&"
export * from "./qasHeldesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f76b51a",
  null
  
)

export default component.exports